import { Employee, EmployeeFormData, EmployeeListResponse } from '../types/employee.types';
import { employeeApi } from '../api/employeeApi';

export const fetchEmployees = async (params: {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  employeeType?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
} = {}): Promise<EmployeeListResponse> => {
  return employeeApi.getAll(params);
};

export const fetchEmployeeById = async (id: string): Promise<Employee> => {
  return employeeApi.getById(id);
};

export const createEmployee = async (data: EmployeeFormData): Promise<Employee> => {
  return employeeApi.create(data);
};

export const updateEmployee = async (id: string, data: Partial<EmployeeFormData>): Promise<Employee> => {
  return employeeApi.update(id, data);
};

export const deleteEmployee = async (id: string): Promise<void> => {
  return employeeApi.delete(id);
};

export const updateEmployeeStatus = async (
  id: string,
  status: 'ACTIVE' | 'INACTIVE' | 'ON_LEAVE' | 'TERMINATED'
): Promise<Employee> => {
  return employeeApi.updateStatus(id, status);
};

export const searchEmployees = async (query: string): Promise<Employee[]> => {
  return employeeApi.search(query);
};
